import { $host, $authHost } from './index'
import { httpPoint } from '../utils/const'

import FingerprintJS from '@fingerprintjs/fingerprintjs';

const getFingerprint = async () => {
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    return result.visitorId;
}

export const signin = async (login, password) => {
    const { data } = await $host.post(httpPoint.user + 'login', { login, password })
    return data
}

export const registration = async (login, password, email, timezone) => {
    const { data } =
        await $host.post(
            httpPoint.user + 'registration',
            {
                login,
                password,
                email,
                timezone,
                fingerprint: await getFingerprint()
            }
        )
    return data
}

export const check = async () => {
    if (localStorage.getItem('token')) {
        const { data } = await $authHost.get(httpPoint.user + 'auth')
        localStorage.setItem('token', data.token)
        return data
    }
}


